import axios from 'axios';
import {
  GET_ERRORS,
  CLEAR_ERRORS,
  GET_PRODUCT,
  GET_PRODUCTS,
  PRODUCT_LOADING,
  GET_PRODUCT_FOR_REVIEW,
  PUBLISH_PRODUCT,
  CLEAR_PRODUCT_ITEM,
  GET_PRODUCT_ITEM,
  CLEAR_CURRENT_PRODUCT,
  PUBLISH_PRODUCT_NO_UPDATE,
  EMAIL_PRODUCT_SENT,
  GET_COMPANY_PRODUCTS,
} from './types';

// Create product
export const createProduct = (productData, history) => (dispatch) => {
  axios
    .post('/api/products', productData)
    .then((res) => history.push('/dashboard'))
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Edit product
export const editProduct = (productData, product_id, history, isAdmin) => (
  dispatch
) => {
  axios
    .post(`/api/products/${product_id}`, productData)
    .then((res) => {
      if (productData.get('isreviewed') === 'false' && isAdmin) {
        history.push('/review');
      } else {
        history.push('/dashboard');
      }
    })
    .catch((err) => {
      dispatch(clearErrors());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Delete product by ID
export const deleteProductByID = (product_id, history) => (dispatch) => {
  dispatch(clearErrors());
  axios
    .delete(`/api/products/${product_id}`)
    .then((res) => history.push('/dashboard'))
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Get current product
export const getCurrentProduct = () => (dispatch) => {
  dispatch(setProductLoading());
  axios
    .get('/api/products')
    .then((res) =>
      dispatch({
        type: GET_PRODUCT,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_PRODUCT,
        payload: {},
      })
    );
};

// Get all products
export const getProducts = () => (dispatch) => {
  dispatch(setProductLoading());
  axios
    .get('/api/products/all')
    .then((res) =>
      dispatch({
        type: GET_PRODUCTS,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_PRODUCTS,
        payload: null,
      })
    );
};

// Get products for review
export const getProductsForReview = () => (dispatch) => {
  dispatch(setProductLoading());
  axios
    .get('/api/products/review')
    .then((res) =>
      dispatch({
        type: GET_PRODUCT_FOR_REVIEW,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Publish product no update
export const publishProductNoUpdate = (product_id, history) => (dispatch) => {
  axios
    .get(`/api/products/review/${product_id}`)
    .then((res) => history.push('/review'))
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Publish product
export const publishProduct = (product_id) => (dispatch) => {
  axios
    .get(`/api/products/review/${product_id}`)
    .then((res) =>
      dispatch({
        type: PUBLISH_PRODUCT,
        payload: product_id,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Send Email Request to Company
export const emailProductRequest = (userData) => (dispatch) => {
  dispatch(clearErrors());
  axios
    .post('api/products/email/request', userData)
    .then((res) =>
      dispatch({
        type: EMAIL_PRODUCT_SENT,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      })
    );
};

// Get product by ID
export const getProductByID = (id) => (dispatch) => {
  dispatch(clearErrors());
  dispatch(setProductLoading());
  axios
    .get(`/api/products/${id}`)
    .then((res) =>
      dispatch({
        type: GET_PRODUCT_ITEM,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_PRODUCT_ITEM,
        payload: null,
      })
    );
};

// Get product by company
export const getProductByCompany = (id) => (dispatch) => {
  dispatch(clearErrors());
  dispatch(setProductLoading());
  axios
    .get(`/api/products/company/${id}`)
    .then((res) =>
      dispatch({
        type: GET_COMPANY_PRODUCTS,
        payload: res.data,
      })
    )
    .catch((err) =>
      dispatch({
        type: GET_COMPANY_PRODUCTS,
        payload: null,
      })
    );
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};

// Product loading
export const setProductLoading = () => {
  return {
    type: PRODUCT_LOADING,
  };
};

// Clear "product_item" & clear loading
export const clearProductItem = () => {
  return {
    type: CLEAR_PRODUCT_ITEM,
  };
};

// Clear "product" & clear loading
export const clearCurrentProduct = () => {
  return {
    type: CLEAR_CURRENT_PRODUCT,
  };
};
